import { getMediaWithProxy, matchMediaType } from '../../../../utils';
import type {
  GalleryMediaValue,
  LinkMediaValue,
  MediaValue
} from '../../../types';
import type { LegacyInstagramResponseItem } from '../types';

type InstagramMediaValue = Exclude<MediaValue, LinkMediaValue>;

export function getInstagramMedia({
  children,
  media_type: mediaType,
  thumbnail_url: thumbnailUrl = '',
  media_url: mediaUrl = ''
}: Partial<LegacyInstagramResponseItem>): InstagramMediaValue | undefined {
  const type = matchMediaType(mediaType);

  if (type === 'gallery' && children?.data.length) {
    const { thumbnail, src } = getInstagramMedia(children.data[0])!;

    return {
      type: 'gallery',
      thumbnail: thumbnailUrl || thumbnail || src || '',
      items: children.data.map(getInstagramMedia) as GalleryMediaValue['items']
    };
  }

  if (type === 'image') {
    return {
      type,
      src: getMediaWithProxy(mediaUrl)
    };
  }

  if (type === 'video') {
    return {
      type,
      thumbnail: getMediaWithProxy(thumbnailUrl),
      src: mediaUrl
    };
  }

  return;
}
